import React from "react";
import PropTypes from "prop-types";
import watchImage from "@/static/images/password-pets/watch.png";
import hideImage from "@/static/images/password-pets/hide.png";
import sadImage from "@/static/images/password-pets/sad.png";
import blinkImage from "@/static/images/password-pets/blink.png";
import sisterLookImage from "@/static/images/password-pets/sister-look.png";
import sisterWaveImage from "@/static/images/password-pets/sister-wave.png";
import brotherLaughImage from "@/static/images/password-pets/brother-laugh.png";
import "./styles/password-pets.scss";

const images = { watch: watchImage, hide: hideImage, sad: sadImage };

export default function PasswordPets({ mood = "idle" }) {
    return (
        <div
            className={`password-pets password-pets--${mood}`}
            role="img"
            aria-label={
                mood === "hide"
                    ? "三姐弟用双手捂住眼睛"
                    : mood === "sad"
                      ? "三姐弟露出沮丧的表情"
                      : "三姐弟看着输入框"
            }
        >
            {Object.entries(images).map(([state, src]) => (
                <img
                    key={state}
                    className={`password-pets__image password-pets__image--${state}`}
                    src={src}
                    alt=""
                    aria-hidden="true"
                    draggable="false"
                />
            ))}
            {[
                ["sister-wave", sisterWaveImage],
                ["brother-laugh", brotherLaughImage],
                ["sister-look", sisterLookImage],
            ].map(([state, src]) => (
                <img
                    key={state}
                    className={`password-pets__image password-pets__image--${state}`}
                    src={src}
                    alt=""
                    aria-hidden="true"
                    draggable="false"
                />
            ))}
            <img
                className="password-pets__image password-pets__image--blink"
                src={blinkImage}
                alt=""
                aria-hidden="true"
                draggable="false"
            />
        </div>
    );
}

PasswordPets.propTypes = {
    mood: PropTypes.oneOf(["idle", "watch", "hide", "sad"]),
};
